import http from '../../../../shared/http';
import endpoints from '../../../../../config/endpoints';

const ROWS_LIMIT = 10;

const createDashboardVisits = ({ namespace, stateNodeName }) => {
	const initialState = {
		rows: [],
		total: 0
	};

	const FETCH_DATA_SUCCESS = `${namespace}/${stateNodeName}-fetch-data-success`;
	const FETCH_MORE_SUCCESS = `${namespace}/${stateNodeName}-fetch-more-success`;

	function request(affiliateId, filters, dates, offset, successActionType) {
		return http({
			url: endpoints.DASHBOARD_VISITS.BY_AFFILIATE.replace('{id}', affiliateId),
			method: 'get',
			query: { filters, dates, offset, limit: ROWS_LIMIT },
			actions: [successActionType]
		});
	}

	const actions = {
		fetchData: (affiliateId, filters, dates) => (dispatch, getState) => {
			return request(affiliateId, filters, dates, 0, FETCH_DATA_SUCCESS)(dispatch);
		},
		fetchMore: (affiliateId, filters, dates) => (dispatch, getState) => {
			const offset = getState().affiliateProfile[stateNodeName].rows.length;
			return request(affiliateId, filters, dates, offset, FETCH_MORE_SUCCESS)(dispatch);
		}
	};

	// reducers
	const reducers = {
		[FETCH_DATA_SUCCESS]: (state, action) => {
			const { rows, total } = action.payload.data;
			return {
				...state,
				[stateNodeName]: {
					rows,
					total
				}
			};
		},
		[FETCH_MORE_SUCCESS]: (state, action) => {
			const { rows, total } = action.payload.data;
			return {
				...state,
				[stateNodeName]: {
					rows: state[stateNodeName].rows.concat(rows),
					total
				}
			};
		}
	};

	return {
		initialState,
		actions,
		reducers
	};
};

export default createDashboardVisits;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/dashboard-visits/index.js